import ArrowUpIcon from 'assets/icons/arrowUp.svg';
import ArrowUpStrokeIcon from 'assets/icons/arrowUpStroke.svg';
import cn from 'classnames/bind';
import DynamicComponent from 'ui/base/DynamicComponent';

import s from './ArrowUp.module.css';

const cx = cn.bind(s);

const ArrowUp = ({
  children, className, isOpen, isStroke = false, ...attrs
}) => {
  const component = isStroke ? ArrowUpStrokeIcon : ArrowUpIcon
  return (
    <DynamicComponent tag={component} className={cx(className, 'arrow', {
      arrowActive: isOpen,
    })} {...attrs}/>
  )};

export default ArrowUp;
